import React from 'react'
import { LikeOutlined, EyeOutlined, MessageOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { CommonUtility } from 'utility'

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  // padding: 0 10px;
`
const StatItem = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50px;
  color: #5c67ca;
  padding: 10px;
  font-size: 24px;
  font-weight: bold;
  justify-content: center;
  @media (max-width: 1280px) {
    font-size: 18px;
    padding: 5px;
  }
`
export const StatWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 5px 10px;
  border-radius: 8px;
  gap: 5px;
  display: flex;
  align-items: center;
`
export const BoldSpan = styled.span`
  color: #4c4c4c;
  font-weight: bold;
  font-size: 14px;
`

export const VideoStats = ({ item, className }) => (
  <StatsContainer className={className}>
    <StatWrapper>
      <StatItem>
        <LikeOutlined />
      </StatItem>
      <BoldSpan>{CommonUtility.numberFormat(item?.votes_count || 0)}</BoldSpan>
    </StatWrapper>

    <StatWrapper>
      <StatItem>
        <EyeOutlined />
      </StatItem>
      <BoldSpan>{CommonUtility.numberFormat(item?.views_count || 0)}</BoldSpan>
    </StatWrapper>

    <StatWrapper>
      <StatItem>
        <MessageOutlined />
      </StatItem>
      <BoldSpan>
        {CommonUtility.numberFormat(item?.comment_count || 0)}
      </BoldSpan>
    </StatWrapper>
  </StatsContainer>
)
